const config = require('../config');
const apiConfig = require('../api-config');
const apiFactory = require('../resources/dataExports/api-factory');
const serviceFactory = require('../resources/dataExports/service-factory');
const base64 = require('base-64');
const headers = { Accept: 'application/json' };

  function addRoutes({ requestHandler } = {}) {
    const api = apiFactory({
      requestHandler,
      baseUrl: `${config.baseUrl}/excelexports/${apiConfig.apiversion}/`,
      authToken: config.authToken,
    });
    const service = serviceFactory({ api });

    return app => app
    .match((`[{keys:metaData}].dataExports.initiateDataExtract[{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.initiateDataExtract(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match((`[{keys:metaData}].dataExports.getExtractVolume[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getExtractVolume(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match((`[{keys:metaData}].dataExports.getDistinctDates[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getDistinctDates(req.params)
            .then(response => res.value(response))
            .catch(res.error)
      )))
}


module.exports = addRoutes;
